"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressFormBasic = void 0;
var _mui = require("@ori-ui/mui");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _Localization = require("../Localization");
var _components = require("../components");
var _constants = require("../constants");
var _TranslationKey = require("../models/TranslationKey");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
const AddressFormBasic = props => {
  const {
    showDeleteButton = false,
    hideActionButtons = false,
    metadataConfig,
    defaultValues,
    onSubmitErrors,
    onSubmitModelsErrors,
    onCancel,
    onDelete,
    onSubmit,
    resolver
  } = props;
  const {
    data: formatAddressFields
  } = (0, _globalApiClientReact.useGetAddressFormat)('Searched');
  const methods = (0, _reactHookForm.useForm)({
    resolver,
    reValidateMode: 'onChange',
    mode: 'all',
    defaultValues
  });
  const {
    watch,
    formState: {
      isSubmitting,
      errors,
      isValid
    },
    setError,
    handleSubmit
  } = methods;
  const correctIsValid = Object.keys(errors).length === 0 && isValid;
  const values = watch();
  const onCancelInternal = () => {
    methods.reset({
      ...defaultValues
    });
    onCancel?.();
  };
  const mapSubmitErrors = (0, _react.useCallback)(errorArr => {
    errorArr.forEach(item => {
      const {
        value,
        key
      } = item;
      if (key[0]) {
        const fixedKey = key[0].toLowerCase() + key.slice(1);
        if (value) {
          setError(fixedKey, {
            message: value
          });
        }
      }
    });
  }, [setError]);
  (0, _react.useEffect)(() => {
    if (onSubmitErrors && onSubmitErrors.length > 0) {
      mapSubmitErrors(onSubmitErrors);
    }
  }, [onSubmitErrors, mapSubmitErrors]);
  const setAddressToForm = address => {
    Object.entries(address).forEach(([name, inputValue]) => {
      const options = inputValue?.toString() ? {
        shouldValidate: true,
        shouldDirty: true
      } : {};
      methods.setValue(name, inputValue, options);
    });
  };
  const {
    country,
    searchOptions,
    kycOperations,
    operations
  } = metadataConfig;
  const isFormDisabled = () => {
    if (values.addressType === _constants.KycAddressType) {
      const canCreate = Boolean(kycOperations?.create?.isEnabled) && !defaultValues.addressId;
      const canEdit = Boolean(kycOperations?.update?.isEnabled) || canCreate;
      if (!canEdit) {
        return true;
      }
    } else {
      const canCreate = Boolean(operations?.create?.isEnabled) && !defaultValues.addressId;
      const canEdit = Boolean(operations?.update?.isEnabled) || canCreate;
      if (!canEdit) {
        return true;
      }
    }
    return false;
  };
  const isSubscriptionAddress = values.addressType === 'Subscription';
  const isFieldDisabled = isFormDisabled();
  const maxResults = searchOptions?.maxResults;
  const isDeleteEnable = values.addressType === _constants.KycAddressType ? kycOperations?.delete?.isEnabled : operations?.delete?.isEnabled;
  const canDelete = isDeleteEnable && showDeleteButton && onDelete && !isSubscriptionAddress;
  const isSearchEnabled = !isFieldDisabled && searchOptions?.isEnabled;
  const formatedAddress = formatAddressFields ? (0, _utils.getOptionLabelSearched)(0, values, formatAddressFields) : '';
  const isSearchedAddressDisabled = !isSearchEnabled && !!formatedAddress.length;
  const singleLineAddress = !formatedAddress ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
    size: {
      xs: 12
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
      mt: 4,
      mb: 4,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "caption",
        width: "100%",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          defaultMessage: _constants.defaultTranslations.searchedAddress,
          id: _TranslationKey.TranslationKey.searchedAddress
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "body1",
        children: formatedAddress
      })]
    })
  }) : null;
  const addressAutoCompleteWithHeader = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Grid, {
    size: {
      xs: 12
    },
    style: {
      order: searchOptions?.displayOrder
    },
    children: [isSearchEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.AddressAutoComplete, {
      name: "autocomplete",
      country: defaultValues.country ?? country?.availableOptions[0],
      minSearchLength: 3,
      setAddressToForm: setAddressToForm,
      maxResults: maxResults,
      searchOptions: searchOptions,
      fields: formatedAddress
    }) : null, isSearchedAddressDisabled ? singleLineAddress : null]
  });
  const [confirmOpened, setConfirmOpened] = (0, _react.useState)(false);
  const deleteButton = canDelete && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.DeleteButton, {
    dataTestId: "address-form-delete",
    onClick: () => setConfirmOpened(true)
  });
  const confirmCanceled = () => setConfirmOpened(false);
  const addressContent = operations?.read?.isEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactHookForm.FormProvider, {
    ...methods,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FormValidationSummary, {
      invalidPropertyErrors: onSubmitModelsErrors
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.StyledForm, {
      noValidate: true,
      autoComplete: "off",
      onSubmit: handleSubmit(onSubmit),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.AddressFormFields, {
        enablePrimaryCheckbox: !isSubscriptionAddress,
        config: metadataConfig,
        isFieldDisabled: isFieldDisabled,
        addressAutoCompleteWithHeader: addressAutoCompleteWithHeader,
        initialValues: defaultValues,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Grid, {
          size: {
            xs: 12
          },
          mt: 1,
          style: {
            order: 97
          },
          children: [deleteButton, !hideActionButtons && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ActionButtons, {
            alwaysShowCancel: true,
            isSubmitting: isSubmitting,
            isValid: correctIsValid,
            isDisabled: isFieldDisabled,
            canRead: values.addressType === _constants.KycAddressType ? kycOperations?.read?.isEnabled : operations.read.isEnabled,
            handleCancel: onCancelInternal
          })]
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ConfirmDeleteDialog, {
      opened: confirmOpened,
      handleCancel: confirmCanceled,
      handleConfirm: onDelete,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        align: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          defaultMessage: _constants.defaultTranslations.confirmAddressDeleteInfo,
          id: _TranslationKey.TranslationKey.confirmAddressDeleteInfo
        })
      })
    })]
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.StyledDivRoot, {
    children: addressContent
  });
};
exports.AddressFormBasic = AddressFormBasic;
//# sourceMappingURL=AddressFormBasic.js.map